import React from 'react'
import {isMobile} from '../../../../../commons/selectors/environment'
import {useMembersPageSelector} from '../../hooks/runtime'
import {hasError} from '../../selectors/events'
import {ErrorState} from '../error-state'
import {EventsList} from '../events-list'
import {EventsTabs} from '../events-tabs'
import {Header} from '../header'
import {Divider} from '../styled-components/divider'

export const Events = () => {
  const mobile = useMembersPageSelector(isMobile)
  const error = useMembersPageSelector(hasError)

  if (error) {
    return <ErrorState />
  }

  return (
    <>
      <Header />
      <EventsTabs />
      {!mobile ? <Divider /> : null}
      <EventsList />
    </>
  )
}
